"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CollisionType;
(function (CollisionType) {
    CollisionType["Bonk"] = "bonk";
    CollisionType["Obstacle"] = "obstacle";
})(CollisionType || (CollisionType = {}));
exports.default = CollisionType;
